import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAppDispatch } from "@/store/hooks";
import { loginThunk } from "@/store/slices/authSlice";

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const resultAction = await dispatch(
      loginThunk({
        loginId: email,
        password,
      })
    );
    const payload = resultAction.payload
    if (payload.status !== 200) {
      return setErrorMsg(payload.message)
    }
    console.log(resultAction)

    if (loginThunk.fulfilled.match(resultAction)) {
      navigate("/", { replace: true });
    }
  };
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: "#F5F6F8" }}
    >
      <div className="w-full" style={{ maxWidth: "400px" }}>
        <div className="text-center mb-8">
          <div
            className="inline-flex items-center justify-center w-12 h-12 rounded-xl mb-4"
            style={{ backgroundColor: "#2563EB" }}
          >
            <i className="ri-calendar-check-line text-white text-xl"></i>
          </div>
          <p className="text-sm font-medium" style={{ color: "#6B7280" }}>
            드레스 투어 스케줄링
          </p>
        </div>

        <div
          className="rounded-xl px-8 py-8"
          style={{
            backgroundColor: "#FFFFFF",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.05)",
          }}
        >
          <div className="mb-6">
            <h1
              className="font-semibold mb-1"
              style={{ fontSize: "22px", color: "#111827" }}
            >
              로그인
            </h1>
            <p style={{ fontSize: "14px", color: "#6B7280" }}>
              발급 받은 계정을 이용해서 로그인해주세요
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">

            

            {/* Email */}
            <div>
              <label className="block text-sm font-medium mb-1.5">
                아이디
              </label>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="아이디 입력"
                className="w-full text-sm"
                style={{
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  padding: "12px 14px",
                }}
              />
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium mb-1.5">
                비밀번호
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full text-sm pr-11"
                  style={{
                    border: "1px solid #E5E7EB",
                    borderRadius: "8px",
                    padding: "12px 14px",
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2"
                >
                  👁
                </button>
              </div>
            </div>
            {/* 에러 메시지 */}
            {errorMsg && (
              <div style={{ color: "red", fontSize: "13px" }}>
                {errorMsg}
              </div>
            )}
            {/* Submit */}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full text-white"
              style={{
                backgroundColor: isLoading ? "#93C5FD" : "#2563EB",
                height: "44px",
                borderRadius: "8px",
              }}
            >
              {isLoading ? "로그인 중..." : "로그인"}
            </button>
          </form>
          
        </div>
      </div>
    </div>
  );
}